import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import FileNameIconBase from 'components/file-name-icon'
import DownloadButtonBase from 'components/download-button'

export const FileNameIcon = styled(FileNameIconBase)`
    ${svgStroke()}
`

export const DownloadButton = styled(DownloadButtonBase)`
    text-decoration: none !important;
`